import { connect } from 'react-redux';

import ContentBlocks from './contentBlocks';

const mapStateToProps = state => ({
  embeds: state.app.pageData.embeds
});

export default connect(mapStateToProps)(ContentBlocks);
